/* ============================================================
   IA SHOP ALL — behavior
   Extracted from the inline <script> in ia-page-shop-all.liquid.
   Cart, quantity stepper, variant pills, product search, sticky nav,
   and the protein filter (grid-only — no hero swap, no hardcoded prices).
   ============================================================ */
(function () {
  'use strict';

  /* ---- Native cart integration -------------------------------------------
     Use the theme's existing cart-drawer sections and pub/sub events so Shop
     All actions stay synchronized with the header bubble and drawer. */
  function iaCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function iaCartSections(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (section) { return section.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function iaPublishCartUpdate(source, variantId, cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      return Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
        source: source,
        productVariantId: String(variantId),
        variantId: String(variantId),
        cartData: cartData
      }));
    }
    return Promise.resolve();
  }

  function iaCartRequest(url, body, source, variantId, openDrawer) {
    var cart = iaCartDrawer();
    if (cart) {
      body.sections = iaCartSections(cart);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'The cart could not be updated.');
        }
        return data;
      });
    }).then(function (data) {
      return iaPublishCartUpdate(source, variantId, data).then(function () {
        if (cart && openDrawer && data.sections && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
        return data;
      });
    });
  }

  window.iaCartAdd = function (variantId, sourceElement) {
    var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';
    return iaCartRequest(addUrl, { id: Number(variantId), quantity: 1 }, 'ia-shop-all', variantId, true);
  };

  /* ---- Add to cart ------------------------------------------------------ */
  window.iaAddToCart = function (btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    var originalText = btn.textContent;
    var isPlusButton = btn.classList.contains('ia-sa__card-plus');

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    if (!btn.classList.contains('ia-sa__card-plus')) btn.textContent = 'Adding…';

    window.iaCartAdd(variantId, btn).then(function () {
      btn.textContent = isPlusButton ? '✓' : 'Added';
      window.setTimeout(function () { btn.textContent = originalText; }, 1600);
    }).catch(function (err) {
      console.error('Add to cart failed', err);
      btn.setAttribute('title', err.message);
      btn.textContent = isPlusButton ? '!' : 'Try again';
      window.setTimeout(function () { btn.textContent = originalText; }, 1800);
    }).finally(function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
    });
  };

  /* ---- Variant pill select on cards --------------------------------------- */
  window.iaSaVariant = function (pill, event) {
    event.preventDefault();
    event.stopPropagation();
    var productId = pill.dataset.productId;
    document.querySelectorAll('.ia-sa__variant-pill[data-product-id="' + productId + '"]').forEach(function (p) {
      p.classList.remove('is-active');
    });
    pill.classList.add('is-active');

    var priceEl = document.getElementById('ia-sa-price-' + productId);
    if (priceEl) {
      var cents = parseInt(pill.dataset.price, 10);
      priceEl.textContent = (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace(/\.00$/, '');
    }

    var card = pill.closest('.ia-sa__card');
    if (card) {
      var plusBtn = card.querySelector('.ia-sa__card-plus');
      if (plusBtn) plusBtn.dataset.variantId = pill.dataset.variantId;
    }
  };

  /* ---- Protein filter — filters the grid only. No hero swap, so there is
     nothing here that can drift out of sync with the catalogue's real prices. */
  document.addEventListener('DOMContentLoaded', function () {
    var filterBtns = document.querySelectorAll('#protein-filters .ia-sa__filter-btn');
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        var filter = this.dataset.filter;

        var grid = document.querySelector('#sa-proteins .ia-sa__grid');
        if (!grid) return;
        var cards = grid.querySelectorAll('.ia-sa__card[data-protein]');
        var visibleCount = 0;
        cards.forEach(function (card) {
          var match = filter === 'all' || card.dataset.protein === filter;
          card.style.display = match ? '' : 'none';
          if (match) visibleCount++;
        });
        var emptyMsg = grid.querySelector('.ia-sa__filter-empty');
        if (visibleCount === 0) {
          if (!emptyMsg) {
            emptyMsg = document.createElement('p');
            emptyMsg.className = 'ia-sa__filter-empty';
            grid.appendChild(emptyMsg);
          }
          emptyMsg.textContent = 'No ' + filter + ' products available right now.';
          emptyMsg.style.display = '';
        } else if (emptyMsg) {
          emptyMsg.style.display = 'none';
        }
      }.bind(btn));
    });

    /* ---- Sticky nav active state on scroll -------------------------------- */
    var sections = document.querySelectorAll('[id^="sa-"]');
    var navLinks = document.querySelectorAll('.ia-sa__sticky-link');
    if (sections.length && navLinks.length && window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            navLinks.forEach(function (l) { l.classList.remove('is-active'); });
            var active = document.querySelector('.ia-sa__sticky-link[data-target="' + entry.target.id + '"]');
            if (active) active.classList.add('is-active');
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      sections.forEach(function (s) { observer.observe(s); });
    }

    /* ---- Smooth scroll for category tiles + sticky nav -------------------- */
    document.querySelectorAll('.ia-sa__cat-pane, .ia-sa__sticky-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (href && href.charAt(0) === '#') {
          e.preventDefault();
          var target = document.querySelector(href);
          if (target) {
            var stickyNav = document.querySelector('.ia-sa__sticky-nav');
            var offset = stickyNav ? stickyNav.offsetHeight + 16 : 80;
            window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
          }
        }
      });
    });
  });

  /* ---- Product search: queries Shopify's predictive search by title,
     renders results, and hides the browsing sections while active. --------- */
  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('ia-sa-product-search');
    var clearBtn = document.getElementById('ia-sa-search-clear');
    var summary = document.getElementById('ia-sa-search-summary');
    var results = document.getElementById('ia-sa-search-results');
    var count = document.getElementById('ia-sa-search-results-count');
    var grid = document.getElementById('ia-sa-search-results-grid');
    if (!input) return;

    var timer, controller, requestId = 0;

    function normalise(v) {
      return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function formatPrice(raw) {
      var n = Number(raw);
      if (!isFinite(n)) return '';
      var dollars = String(raw).indexOf('.') > -1 ? n : n / 100;
      return dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
    function normaliseProduct(p) {
      var variants = Array.isArray(p.variants) ? p.variants : [];
      var available = variants.filter(function (v) { return v.available; })[0] || variants[0];
      var img = p.featured_image || p.image;
      var imgUrl = typeof img === 'string' ? img : (img && (img.url || img.src));
      return {
        title: p.title || '',
        url: p.url || '',
        price: formatPrice(p.price),
        image: imgUrl || '',
        variantId: available && available.id ? String(available.id) : ''
      };
    }
    function addCard(p) {
      if (!grid) return;
      var card = document.createElement('article');
      card.className = 'ia-sa__search-result-card';
      if (p.image && p.url) {
        var mediaLink = document.createElement('a');
        mediaLink.className = 'ia-sa__search-result-media';
        mediaLink.href = p.url;
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title;
        img.loading = 'lazy';
        mediaLink.appendChild(img);
        card.appendChild(mediaLink);
      }
      var body = document.createElement('div');
      body.className = 'ia-sa__search-result-body';
      var title = document.createElement(p.url ? 'a' : 'p');
      title.className = 'ia-sa__search-result-title';
      if (p.url) title.href = p.url;
      title.textContent = p.title;
      body.appendChild(title);
      if (p.price) {
        var price = document.createElement('p');
        price.className = 'ia-sa__search-result-price';
        price.textContent = p.price;
        body.appendChild(price);
      }
      var actions = document.createElement('div');
      actions.className = 'ia-sa__search-result-actions';
      if (p.variantId) {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'ia-sa__search-result-add';
        add.dataset.variantId = p.variantId;
        add.textContent = 'Add to cart';
        add.addEventListener('click', function () { window.iaAddToCart(add); });
        actions.appendChild(add);
      }
      if (p.url) {
        var details = document.createElement('a');
        details.className = 'ia-sa__search-result-details';
        details.href = p.url;
        details.textContent = 'View details';
        actions.appendChild(details);
      }
      if (actions.children.length) body.appendChild(actions);
      card.appendChild(body);
      grid.appendChild(card);
    }

    function runSearch() {
      var term = input.value.trim();
      if (clearBtn) clearBtn.hidden = !term;
      if (grid) grid.replaceChildren();

      if (!term) {
        if (controller) controller.abort();
        document.body.classList.remove('ia-sa-searching');
        if (results) results.hidden = true;
        if (count) count.textContent = '';
        if (summary) summary.textContent = '';
        return;
      }

      document.body.classList.add('ia-sa-searching');
      if (results) results.hidden = false;
      if (count) count.textContent = 'Searching products…';
      if (summary) summary.textContent = 'Searching products…';

      var thisRequest = ++requestId;
      if (controller) controller.abort();
      controller = new AbortController();

      var endpoint = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=24&resources[options][unavailable_products]=last';

      fetch(endpoint, { signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('search failed'); return r.json(); })
        .then(function (payload) {
          if (thisRequest !== requestId) return;
          var products = (payload.resources && payload.resources.results && payload.resources.results.products) || [];
          var seen = {};
          var matches = products.filter(function (p) {
            var key = p.id || p.url || p.title;
            if (!key || seen[key] || !normalise(p.title).includes(normalise(term))) return false;
            seen[key] = true;
            return true;
          }).map(normaliseProduct);

          if (grid) grid.replaceChildren();
          var label = matches.length + (matches.length === 1 ? ' product found' : ' products found') + ' for \u201c' + term + '\u201d';
          if (count) count.textContent = label;
          if (summary) summary.textContent = matches.length ? label + '.' : 'No products match \u201c' + term + '.\u201d Try another search.';

          if (matches.length) {
            matches.forEach(addCard);
          } else if (grid) {
            var empty = document.createElement('p');
            empty.className = 'ia-sa__search-result-empty';
            empty.textContent = 'No products match \u201c' + term + '.\u201d Try another search.';
            grid.appendChild(empty);
          }
        })
        .catch(function (err) {
          if (err.name === 'AbortError' || thisRequest !== requestId) return;
          if (grid) grid.replaceChildren();
          if (count) count.textContent = 'Search unavailable';
          if (summary) summary.textContent = 'We could not load product results. Please try again.';
        });
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(runSearch, 180);
    });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        window.clearTimeout(timer);
        input.value = '';
        runSearch();
        input.focus();
      });
    }
  });
})();
